/* Generic "?" info popout for product options.
   Reads window.__optInfo = [{ match, title, html }, ...] and, for each
   product option label whose name contains `match` (case-insensitive),
   adds a small circled ? to the right that opens a popout showing
   `title` + `html`. Same look as the size "?" popout. */
(function () {
  'use strict';
  if (window.__optInfoInit) return;
  window.__optInfoInit = true;

  var ITEMS = window.__optInfo || [];
  if (!ITEMS.length) return;

  var css = [
    '.opti-trigger{display:inline-flex;align-items:center;justify-content:center;',
    'width:17px;height:17px;margin-left:8px;border:1px solid rgba(35,35,35,0.35);',
    'border-radius:50%;font:400 11px/1 "Hanken Grotesk",sans-serif;color:#232323;',
    'text-decoration:none;vertical-align:1px;cursor:pointer;background:none;padding:0;flex:0 0 auto;}',
    '.opti-trigger:hover{background:#232323;color:#f8f7f5;}',
    '.opti-overlay{position:fixed;inset:0;background:rgba(35,35,35,0.45);z-index:9999;',
    'display:flex;align-items:center;justify-content:center;padding:24px;}',
    '.opti-panel{background:#f8f7f5;color:#232323;max-width:380px;width:100%;',
    'padding:40px 32px 32px;text-align:left;position:relative;',
    'font:300 14px/1.6 "Hanken Grotesk",sans-serif;}',
    '.opti-title{font:400 22px/1.3 "Cormorant Garamond",Georgia,serif;',
    'letter-spacing:0.06em;margin:0 0 14px;}',
    '.opti-panel p{margin:0 0 12px;color:#4a4744;font-size:13.5px;}',
    '.opti-panel p:last-child{margin-bottom:0;}',
    '.opti-close{position:absolute;top:8px;right:8px;width:36px;height:36px;border:0;',
    'background:none;font-size:18px;color:#232323;cursor:pointer;padding:0;line-height:1;}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function matchFor(name) {
    var t = name.toLowerCase();
    for (var i = 0; i < ITEMS.length; i++) {
      if (t.indexOf(ITEMS[i].match.toLowerCase()) !== -1) return ITEMS[i];
    }
    return null;
  }

  function openPopover(item) {
    var overlay = document.createElement('div');
    overlay.className = 'opti-overlay';
    overlay.innerHTML =
      '<div class="opti-panel" role="dialog" aria-label="' + item.title + '">' +
      '<button type="button" class="opti-close" aria-label="Close">&#10005;</button>' +
      '<h3 class="opti-title">' + item.title + '</h3>' +
      item.html +
      '</div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('opti-close')) overlay.remove();
    });
    document.body.appendChild(overlay);
  }

  function makeTrigger(item) {
    var a = document.createElement('button');
    a.type = 'button';
    a.className = 'opti-trigger';
    a.textContent = '?';
    a.setAttribute('aria-label', 'More about ' + item.title);
    a.title = item.title;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openPopover(item);
    });
    return a;
  }

  function scan() {
    var labels = document.querySelectorAll(
      'legend.form__label:not([data-opti]), label.form__label:not([data-opti])'
    );
    for (var i = 0; i < labels.length; i++) {
      var legend = labels[i];
      legend.setAttribute('data-opti', '1');
      var name = '';
      for (var n = 0; n < legend.childNodes.length; n++) {
        if (legend.childNodes[n].nodeType === 3) name += legend.childNodes[n].textContent;
      }
      var item = matchFor(name);
      if (!item) continue;
      legend.appendChild(makeTrigger(item));
    }
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
